import styled from 'styled-components'
import { DISPLAY } from '../ui'

/**
 * A live competition's primary action (site review 59 #1, 2026-10-07): a holder arriving from the ticker found only "Share to invite
 * traders". The button opens the page's own trade panel on the competition pool (buy side): only trades through that pool count, so it is
 * not sent to /swap, whose router may pick another pool. Share stays, as the secondary twin.
 */
export const TRADE_ANCHOR = 'trade-column'

export const enterLabel = (type: string, symbol: string) => (type === 'VOLUME' ? `Trade ${symbol} to enter` : `Buy ${symbol} to enter`)

/** Scroll to the trade panel (instantly when the visitor asks for reduced motion). */
export function goToTrade() {
  const el = typeof document !== 'undefined' ? document.getElementById(TRADE_ANCHOR) : null
  if (!el) return false
  const reduce = typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
  el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' })
  return true
}

/** Green like the token page's Buy, lit like the gold Share button beside it: same height, same radius, full width. */
export const EnterButton = styled.a`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-sizing: border-box;
  width: 100%;
  min-height: 52px;
  padding: 0 22px;
  border-radius: 14px;
  font-family: ${DISPLAY};
  font-weight: 800;
  font-size: 17px;
  line-height: 1.15;
  text-align: center;
  color: #04150d;
  text-decoration: none;
  cursor: pointer;
  background: linear-gradient(180deg, #8ff5c2 0%, #39d98a 55%, #1fae6a 100%);
  box-shadow: 0 14px 30px -14px rgba(57, 217, 138, 0.95), 0 0 0 1px rgba(143, 245, 194, 0.35), inset 0 1px 0 rgba(255, 255, 255, 0.6);
  transition: transform 0.15s ease, filter 0.15s ease, box-shadow 0.15s ease;
  &:hover {
    filter: brightness(1.05);
    transform: translateY(-1px);
    box-shadow: 0 18px 34px -14px rgba(57, 217, 138, 1), 0 0 0 1px rgba(143, 245, 194, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.6);
  }
  &:active {
    transform: translateY(0);
  }
  &:focus-visible {
    outline: 2px solid #8ff5c2;
    outline-offset: 3px;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
    &:hover,
    &:active {
      transform: none;
    }
  }
`
